import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/Service/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-validate-otp',
  templateUrl: './validate-otp.component.html',
  styleUrls: ['./validate-otp.component.css']
})
export class ValidateOtpComponent implements OnInit {

  otpkey = '';
  password = '';
  confirmPassword = '';
  responseData: any;
  page: boolean = true;
  recievedID!: string;
  load = false;
  constructor(
    private route: Router,
    private service: AuthService,
    private notification: ToastrService
  ) { }

  ngOnInit(): void {
  }


  Verify = new FormGroup({
    otpkey: new FormControl("", Validators.required)
  })

  NewSetPassword = new FormGroup({
    password: new FormControl("", Validators.required),
    confirmPassword: new FormControl("", Validators.required)
  })

  switchPages(){
    this.page = !this.page;
  }

  ProceedOtp(){
    // this.load = true;
    if(this.Verify.valid){
      this.service.fpOtpVerification(this.Verify.value).subscribe((res: any) => {
        console.log(res)
        if(res.status == 200){
          this.responseData = res;
         this.recievedID = res.result[0]?.email;
          Swal.fire('OTP Confirmed', 'success')
          this.switchPages()
        } 
        else if(res.status == 204){
          Swal.fire({
            icon: 'warning',
            title: `${res.message}`,
            footer: ''
          });
          
        } 
        else {
          Swal.fire({
            icon: 'error',
            title: `${res.message}`,
            footer: ''
          });
          this.load = false;
        }
      }), (error: { message: string | undefined; }) => {
        this.notification.error(error.message)
        this.load = false;
      }
    }

  }

  changePassword(){
    if(this.NewSetPassword.valid){
      let payload = this.NewSetPassword.getRawValue()
      payload.email = this.recievedID;
      console.log(payload)
      this.service.setNewPassword(payload).subscribe((res: any) => {
        console.log(res)
        if(res.status == 200){
          this.responseData = res;
          Swal.fire(`${res.message}`, 'success')
          this.route.navigate(['/login'])
        } 
        else if(res.status == 204){
          Swal.fire({
            icon: 'warning',
            title: `${res.message}`,
            footer: 'An error occured '
          });
          
        } 
        else {
          Swal.fire({
            icon: 'error',
            title: `${res.message}`,
            footer: 'Fatal error occured'
          });
          this.load = false;
        }
      }), (error: { message: string | undefined; }) => {
        this.notification.error(error.message)
        this.load = false;
      }
    }
  }

}
